(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory3sService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory3s: function (parms) {
                return $ihttp.post({
                    method: 2675,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
